import isGroupedItems from './is-grouped-items';

function getFlatChildren(children) {
  if (isGroupedItems(children)) {
    return children.flatMap((g) => g.items);
  }
  return children;
}

export default getFlatChildren;
